// utils/numberFormat.js
export const formatNumberWithCommas = (value: number | string | null | undefined) => {
    if (value === null || value === undefined) return '';
    return Number(value).toLocaleString('en-US');
};